module.exports = __webpack_public_path__ + "static/media/formatura.2a330cd0.jpg";